import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { getSectionLabel } from 'ion-sections'
import { Articles, SectionMeta } from 'ion-article-cmp'
import Ad from '../components/Ad'
import WingBanners from '../components/WingBanners'
import FORMATS from '../components/AdFormats'
import Sidebar from '../components/Sidebar'
import logo from '../static/general/house-and-garden.svg'
import NoImage from '../static/no-image.png'
import DefaultTemplate from '../templates/Articles/Default'
import NotFound from './NotFound'
import ArticleCard from '../components/ArticleCard'
import { MobileElse } from 'ion-media'
import MagazineCover from '../components/MagazineCover'
import useHasMounted from '../../lib/useHasMounted'
import { DefaultSectionPageSkeleton } from '../components/Skeletons'

const DefaultSectionPage = (props) => {
  // const Template = DefaultTemplateSkeleton  // Uncomment this to run the skeleton only
  const Template = props.template || DefaultTemplate
  const hasMounted = useHasMounted()
  return (
    <>
      <Helmet
        titleTemplate='%s'
        title={props.title || getSectionLabel(props.section)}
      >
        <meta property='fb:app_id' content='293175074032541' />
        <meta property='og:type' content='section' />
        <meta property='og:title' content={props.title || getSectionLabel(props.section)} />
        <meta property='og:image' content={logo} />
        <meta itemProp='headline' content={props.title || 'Latest News from ' + getSectionLabel(props.section)} />
        <meta name='description' content={props.description} />
        <meta itemProp='description' content={props.description} />
        <meta property='og:description' content={props.description} />
        <meta property='og:url' content={props.url} />
        <meta property='keywords' content={props.keywords} />
        <meta name='twitter:site' content={props.twitterName} />
        <meta name='twitter:creator' content={props.twitterName} />
        <meta name='twitter:title' content={props.title || getSectionLabel(props.section)} />
        <meta name='twitter:description' content={props.description} />
        <meta itemprop='image' content={logo} />
        <meta itemprop='thumbnailUrl' content={logo} />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:image:src' content={logo} />
      </Helmet>
      {props.isPage0 &&
        <Articles
          {...props} noDiv className='' loading={() => (<DefaultSectionPageSkeleton sectionLabel={getSectionLabel(props.section)} />)} component={(p) => (
            <>
              <WingBanners useSmall={props.useSmall} isConnected={props.isConnected} location={props.location} onSlotRenderEndedLeft={props.onSlotRenderEndedLeft} onSlotRenderEndedRight={props.onSlotRenderEndedRight} />
              <Ad isConnected={props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${props.section}`} slotId='leaderboard-1' targeting={{ leaderboard: '1' }} collapseEmptyDiv className='advert-leaderboard-1' {...FORMATS.leaderboard} />
              <div id='adngin-leaderboard-1-0' className='advert-leaderboard-1' />
              <div className='wrapper article-listing'>
                <div className='article-list'>
                  <Template {...p} />
                </div>
                <Sidebar {...props}>
                  <MagazineCover />
                </Sidebar>
              </div>
              {hasMounted &&
                <MobileElse>
                  <Ad isConnected={props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${props.section}`} slotId='leaderboard-3' targeting={{ leaderboard: '3' }} collapseEmptyDiv className='advert-leaderboard-3' {...FORMATS.leaderboard} />
                  <Ad isConnected={props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${props.section}`} slotId='interstitial' targeting={{ interstitial: '2' }} collapseEmptyDiv className='advert-interstital' {...FORMATS.interstitial} />
                </MobileElse>}
            </>
          )} section={props.section} sectionLabel={props.sectionLabel} sectionsLabels={props.sectionsLabels} count={18} pageSize={18} noImage={NoImage} notFound={NotFound} withMore
        />}
      {!props.isPage0 &&
        <Articles
          {...props} className='' component={(p) => (
            <div className='wrapper article-listing'>
              <div className='article-list paged'>
                <h1>{p.sectionLabel}</h1>
                {p.articles.map((article) => <ArticleCard key={article.contentKey} article={article} noImage={p.noImage} />)}
                {p.moreButton}
              </div>
              <Sidebar {...props}>
                <MagazineCover />
              </Sidebar>
            </div>
          )} section={props.section} page0Limit={18} pageSize={18} noImage={NoImage} notFound={NotFound} withMore
        />}
      <SectionMeta {...props} />
    </>
  )
}

DefaultSectionPage.defaultProps = {
  component: DefaultTemplate,
  section: 'homepage'
}

export default connect((state) => ({ articles: state.articles }))(DefaultSectionPage)
